import {Component, ViewChild} from '@angular/core';
import {Nav, NavController, Platform} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import {BookPage} from "../pages/book/book";
import {EnvironmentalAlertPage} from "../pages/environmental-alert/environmental-alert";
import {SettingsPage} from "../pages/settings/settings";
import {ContactPage} from "../pages/contact/contact";
import {MapPage} from "../pages/map/map";
import {ListSitePage} from "../pages/list-site/list-site";


@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  @ViewChild(Nav) nav: Nav;
  pages: Array<{title: string, component: any}>;
  rootPage:any = MapPage;

  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen) {
    this.initializeApp();

    this.pages = [
      { title: 'Carte générale', component: MapPage},
      { title: 'Liste des sites & secteurs', component: ListSitePage},
      { title: 'Informations environnementales', component: EnvironmentalAlertPage},
      { title: 'Topoguide références', component: BookPage},
      { title: 'Mes secteurs hors ligne', component: SettingsPage},
      { title: 'Contacts & partenaires', component: ContactPage},
    ];

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    if(page.component.name.toString() !== 'MapPage'){
      this.nav.push(page.component).catch();
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts